import { createApp, h } from 'vue'
import { createInertiaApp } from '@inertiajs/inertia-vue3'
import { InertiaProgress } from '@inertiajs/progress'

createInertiaApp({
    resolve: (name) => import(`./Pages/${name}`),
    setup({ el, app, props, plugin }) {
        createApp({ render: () => h(app, props) })
            .mixin({ methods: { route } })
            .use(plugin)
            .mount(el)
    },
})

InertiaProgress.init({
    color: '#52B4AB'
})

import { Inertia } from '@inertiajs/inertia'

if (window.gtag !== undefined) {
    Inertia.on('navigate', (event) => {
        gtag('event', 'page_view', {
            'page_location': event.detail.page.url
        })
    })
}


import smoothscroll from 'smoothscroll-polyfill'

smoothscroll.polyfill()
